var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-tabs",
        {
          attrs: { "background-color": "blue-grey lighten-5" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab", { key: "trader_configs" }, [_vm._v("Configs")]),
          _c("v-tab", { key: "trader_orders" }, [_vm._v("Orders")]),
          _c("v-tab", { key: "trader_offers" }, [_vm._v("Offers")]),
        ],
        1
      ),
      _c(
        "v-tabs-items",
        {
          staticClass: "mt-4",
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            "v-tab-item",
            { key: "trader_configs" },
            [_c("r-trader-config-page")],
            1
          ),
          _c(
            "v-tab-item",
            { key: "trader_orders" },
            [_c("r-trader-order-page")],
            1
          ),
          _c(
            "v-tab-item",
            { key: "trader_offers" },
            [_c("r-trader-offer-page")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }